import React from 'react';

import styles from './index.module.scss';
import iconSelect from 'asset/image/icon_select.svg';
import { afterLogin } from 'model/login';
import { useDispatch } from 'react-redux';
interface Props {
  mobile: string;
  loginData?: any;
}

const ModifySuccess: React.FC<Props> = ({ mobile, loginData }) => {
  const dispatch = useDispatch();

  async function fastLogin() {
    const { userId, access_token: token } = loginData;

    dispatch(
      afterLogin({
        userId,
        token,
        mobile
      })
    );
  }

  return (
    <div className={styles['modify-success-container']}>
      <img src={iconSelect} className={styles['main-icon']} />
      <div className={styles.desc}>密码设置成功</div>

      <div className={styles.login} onClick={fastLogin}>
        立即进入
      </div>
    </div>
  );
};

export default ModifySuccess;
